export default function MuiFormControlLabel(theme: any) {
  return {
    MuiFormControlLabel: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {},
        },
      ],
      styleOverrides: {
        root: {
          "& .MuiFormControlLabel-label": {
            marginTop: theme.spacing(1.25),
          },
        },
      },
    },
  };
}
